import { InfoCloudDetailPage } from './../info-cloud-detail/info-cloud-detail';
import { CloudsPage } from './../clouds/clouds';
import { MyFirebase } from './../../providers/my-firebase';
import { MyFirebaseList } from './../../providers/my-firebase-list';
import { ModelMetier } from './../../providers/model-metier';
import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

/**
 * Page list all cloud, 
 *  select a cloud, display all licId attached to this cloud.
 */
@Component({
  selector: 'page-info-cloud',
  templateUrl: 'info-cloud.html',
})
export class InfoCloudPage {

  constructor(public modelMetier: ModelMetier, public navCtrl: NavController, public navParams: NavParams,
                public myFirebase : MyFirebase) {
  }


  ionViewDidLoad() {
    console.log('ionViewDidLoad InfoCloudPage');

    this.myList = this.myFirebase.getList( ModelMetier.getCloudsElesRef(), ModelMetier.getCloudsChildrenRef() );
  }


  // List des clouds
  myList : MyFirebaseList;

  // Select un cloud
  itemSelected(eleId, ele) {
    this.navCtrl.push(InfoCloudDetailPage, {parent:this, eleId: eleId, ele:ele });
  }

}




// WEBPACK FOOTER //
// ./src/pages/info-cloud/info-cloud.ts